export const cesija_radi_osiguranja = {
  templateId: 22,
  category: 2,
  templateTitle: "Cesija (ustup potraživanja) radi osiguranja",
  templateDescription: `Cesijom postojeći vjerovnik (cedent) prenosi svoju tražbinu prema dužniku (cesusu) na novog vjerovnika (cesionara). Za prijenos tražbine cesijom nije potreban pristanak dužnika (cesusa). Iako mnogi čine grešku te smatraju da je cesija trostrani ugovor, cesija je ustvari dvostrani ugovor između postojećeg vjerovnika - cedenta i novog vjerovnika - cesionara, a dužnika je potrebno samo obavijestiti da je ustup tražbine (cesija) izvršen. Za točniji odabir načina reguliranja međusobnih odnosa predlažemo da koristite <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a>.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Cesija je promjena vjerovnika u poslovnom odnosu (umjesto starog vjerovnika - cedenta, u poslovni odnos s dužnikom ulazi novi vjerovnik), pri čemu dužnik (cesus) i tražbina, ostaju neizmijenjeni.</p>
    <p>Ukoliko želite provjeriti hoće li ova vrsta ugovora biti ispravan odabir za međusobno reguliranje odnosa, predlažemo korištenje aplikacije <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a> koja će brzo i točno dati rješenje za vašu situaciju. </p>
    <p>Cesijom postojeći vjerovnik (cedent) prenosi svoju tražbinu prema dužniku (cesusu) na novog vjerovnika (cesionara). <strong>Za prijenos tražbine cesijom nije potreban pristanak dužnika (cesusa).</strong></p>
    <p><strong>Cesija je pravno gledajući, dvostrani ugovor između postojećeg vjerovnika - cedenta i novog vjerovnika - cesionara, a dužnika je potrebno samo obavijestiti da je ustup tražbine (cesija) izvršen.</strong></p>
    <p>Ipak, radi praktičnosti, ugovor o cesiji može potpisati i dužnik isključivo u svrhu obavješćivanja o istoj, a nakon čega je dužan ispuniti preuzetu tražbinu novom vjerovniku.</p>
    <p>Važno je reći da je ugovor o cesiji akcesoran, što znači da mu u pravilu prethodi neki drugi pravni posao koji je razlogom cesije (npr. plaćanje duga, kupoprodaja, ustup na ime zaloga, davanje kredita i sl.).</p>
    <p>Cesijom se može ustupiti cijela tražbina, no i dio tražbine.</p>
    <p>Predmetom cesije mogu biti i buduće tražbine, tj. one koje u trenutku sklapanja ugovora o cesiji još ne postoje, no pod pretpostavkom da su određene ili barem odredive, a predmet cesije mogu biti i nedospjele i uvjetne tražbine.</p>
    <p>Postoji više vrsta cesije:</p>
    <ul>
      <li> redovita cesija,</li>
      <li> cesija umjesto ispunjenja/plaćanja,</li>
      <li> cesija radi ispunjenja (naplaćivanja),</li>
      <li> <strong>cesija radi osiguranja.</strong></li>
    </ul>
    <p>Ovdje se obrađuje <strong>cesija radi osiguranja</strong> kod koje je ustupanje tražbine učinjeno radi osiguranja tražbine novog vjerovnika (cesionara) prema starom vjerovniku (cedentu), pri čemu je novi vjerovnik (cedent) dužan brinuti o naplati tražbine pažnjom dobrog gospodarstvenika te nakon naplate,  starom vjerovniku (cedentu) predati višak naplaćenih sredstava.</p>
    <p>Kratke značajke preostalih cesija koje se ne obrađuju ovdje bi bile sljedeće:</p>
    <p><strong>Redovitom cesijom</strong> stari vjerovnik (cedent) ustupa novom vjerovniku (cesionaru) svoju tražbinu koju ima prema svom dužniku (cesusu). <strong>Kod ove vrste cesije nije nužno da je </strong><strong>stari vjerovnik ujedno i dužnik novog vjerovnika.</strong></p>
    <p><strong>Kod cesije umjesto ispunjenja/plaćanja nužno je da stari vjerovnik (cedent) duguje novom vjerovniku (cesionaru) te takvom vrstom cesije prestaje dugovanje starog vjerovnika (cedenta) prema novom vjerovniku (cesionaru)</strong>, no prestaje i tražbina starog vjerovnika (cedenta) prema dužniku (cesusi). Jedino što preostaje nakon takve cesije je tražbina novog vjerovnika (cesionara) prema dužniku (cesusu). </p>
    <p><strong>Cesijom radi ispunjenja (naplaćivanja)</strong>, obveza starog vjerovnika (cedenta) prema novom vjerovniku (cesionaru) <strong>prestaje tek kada novi vjerovnik (cesionar) naplati ustupljenu tražbinu od dužnika.</strong> Svrha cesije radi ispunjenja je da umjesto starog vjerovnika (cedenta), novi vjerovnik (cesionar) naplati tražbinu prema dužniku (cesusu), ali je svrha i ta da novi vjerovnik (cesionar) tom naplatom od cesusa (dužnika) naplati svoju tražbinu koju ima prema cedentu (starom vjerovniku), a po naplati da višak preda cedentu (starom vjerovniku).</p>
    <p>U nastavku prikazujemo međusobne odnose ugovornih strana prije redovite cesije i poslije redovite cesije:</p>
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td rowspan="2" >
            <p><strong>VRSTA CESIJE/OBVEZE UKLJUČENIH STRANA</strong></p>
          </td>
          <td colspan="2" >
            <p><strong>STARI VJEROVNIK (CEDENT)</strong></p>
          </td>
          <td colspan="2" >
            <p><strong>NOVI VJEROVNIK (CESIONAR)</strong></p>
          </td>
          <td colspan="2" >
            <p><strong>CESUS (DUŽNIK)</strong></p>
          </td>
        </tr>
        <tr>
          <td >
            <p>prije cesije</p>
          </td>
          <td >
            <p>poslije cesije</p>
          </td>
          <td >
            <p>prije cesije</p>
          </td>
          <td >
            <p>poslije cesije</p>
          </td>
          <td >
            <p>prije cesije</p>
          </td>
          <td >
            <p>poslije cesije</p>
          </td>
        </tr>
        <tr>
          <td >
            <p><strong>CESIJA RADI OSIGURANJA</strong></p>
          </td>
          <td >
            <p><strong>Ima tražbinu prema dužniku, koju želi ustupiti novom vjerovniku radi osiguranja dugovanja koje ima prema njemu (novom vjerovniku). </strong></p>
            <p><strong></strong></p>
          </td>
          <td >
            <p><strong>Obveza starog vjerovnika prema dužniku ne gasi se trenutkom potpisa ugovora o cesiji, nego tek ako dužnik ispuni obvezu prema novom vjerovniku.</strong></p>
          </td>
          <td >
            <p><strong>Ima tražbinu prema starom vjerovniku te isti želi osigurati, a potom i naplatiti kroz ustupljenu tražbinu starog vjerovnika prema dužniku. </strong></p>
          </td>
          <td >
            <p><strong>Tražbina prema starom vjerovniku, cesionaru ne prestaje trenutkom potpisa ugovora o cesiji, nego tek s ispunjenjem obveze dužnika prema njemu, pri čemu je nakon zadržanja iznosa potrebnog za namirenje vlastite tražbina prema starom vjerovniku, dužan starom vjerovniku isplatiti sav višak.</strong></p>
            <p><strong></strong></p>
            <p><strong> </strong></p>
            <p><strong></strong></p>
            <p><strong></strong></p>
          </td>
          <td >
            <p><strong>Ima dugovanje prema starom vjerovniku.</strong></p>
          </td>
          <td >
            <p><strong>Trenutkom potpisa ugovora o cesiji nastaje mu dugovanje prema novom vjerovniku, dok se gasi obveza prema starom vjerovniku.</strong></p>
          </td>
        </tr>
      </tbody>
    </table>
    <p>Iznimno je bitno naglasiti da s prijenosom tražbine, osim glavnice, na novog vjerovnika (cesionara) prelaze i sva ostala sporedna prava uz tražbinu: pravo prvenstvene naplate, hipoteka, založno pravo, ugovorna kazna i sl., te ista ima pravo ostvarivati protiv dužnika.</p>
    <p></p>
    <p>Stari vjerovnik (cedent) odgovara za postojanje tražbine, a za naplativost tražbine odgovara samo ako je tako ugovoreno, no do visine iznosa koji je primio od novog vjerovnika.</p>
    <p></p>
    <p><strong>Osim gore navedenih razlika između cesija, vrlo je bitno razlikovati ugovore o cesiji u odnosu na promjene na strani dužnika - ugovor o preuzimanju duga, ugovor o pristupanju dugu i ugovor o preuzimanju ispunjenja. </strong></p>
    <p><strong></strong></p>
    <p><strong></strong></p>
    <p><strong>Ugovorne strane mogu svoje međusobne odnose riješiti ugovorom o cesiji, ugovorom o preuzimanju duga, ali i ugovorom o asignaciji, ovisno o ciljevima koje žele postići.</strong></p>
    <p><strong></strong></p>
    <p><strong>Navedene mogućnosti uređenja odnosa izlažu se na primjeru u nastavku:</strong></p>
    <p></p>
    <p><strong>Pretpostavimo da u trenutnom odnosu A duguje B, B duguje C, pa je tako:</strong></p>
    <p><strong>A dužnik B, </strong></p>
    <p><strong>B je vjerovnik A, a dužnik C.</strong></p>
    <p><strong></strong></p>
    <ol type="a">
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju umjesto plaćanja</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionar, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik), čime podmiruje svoje dugovanje prema C. Sklapanjem ugovora prestaje dugovanje B prema C.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju radi ispunjenja (naplaćivanja)</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionar, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik). Sve međusobne obveze prestaju tek kada A ispuni obvezu prema C, za razliku od cesiju umjesto plaćanja kod koje samim sklapanjem ugovora prestaje dugovanje B prema C.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju radi osiguranja</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionaru, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik), radi osiguranja tražbine C prema B. C je dužan brinuti o naplati ustupljene tražbine, a po naplati višak predati B.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz preuzimanje duga</p>
        <p>A (kao novi dužnik) preuzima dugovanje B (stari dužnik) prema C (vjerovnik), a kojim preuzimanjem duga se stvara tražbina A prema B koje se potom kompenzira s ranijom protutražbinom B prema A. Obveza B (stari dužnik) prema C više ne postoji između navedenih subjekata, jer je preuzeta ugovorom o preuzimanju duga (A je preuzeo dug od B).</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz asignaciju</p>
        <p>A (kao upućenik - asignat) na temelju upute B (uputitelja - asignanta) prihvaća ovlast da u ime B podmiri obvezu B prema C, a ujedno C (primatelj upute - asignatar) prima ovlast da ispunjenje primi u svoje ime. Za razliku od cesije umjesto plaćanja i preuzimanja duga, kod ugovora o asignaciji, međusobne obveze prestaju tek s ispunjenjem upute (podmirenjem obveze A, primanjem ispunjenja C).</p>
      </li>
    </ol>
    <p><strong>Dakle, isti poslovni odnos između dužnika i vjerovnika može biti reguliran kroz ugovor o cesiji umjesto ispunjenja/plaćanja, ugovor o cesiji radi ispunjenja (naplaćivanja), ugovor o cesiji radi osiguranja ili kroz ugovor o preuzimanju duga odnosno kroz ugovor o asignaciji, ovisno o poslovnim interesima i dogovoru ugovornih strana.</strong></p>
    
    <p><strong>NAPOMENA: Ovršenik (dužnik) kao poslovni subjekt ne smije  (prema Zakonu o provedbi ovrhe na novčanim sredstvima) sklapati ugovore radi obračunskog plaćanja ako u Jedinstvenom registru računa ima oznaku blokade računa, odnosno zabranu raspolaganja oročenim novčanim sredstvima, ako tim obračunskim plaćanjem kao vjerovnik tražbine (u ovom slučaju, kod cesije se zabrana odnosi na cedenta, a ne na cesionara ili cesusa) onemogućuje ili izbjegava primitak ispunjenja obveze u novcu. Novčana kazna u slučaju kršenja navedenog može biti do 500.000,00 kn. </strong></p>
   
    <p><strong> Osim toga, sukladno Zakonu o obveznim odnosima takav ugovor je ništetan (ne proizvodi nikakve pravne učinke) jer je protivan prisilnim propisima (Zakon o provedbi ovrhe na novčanim sredstvima). <p></strong>
    <p><strong>Vjerovnik koji je znao za postojeću blokadu računa svojeg dužnika može biti kazneno odgovoran (za kazneno djelo prijevare u
    gospodarskom poslovanju te pomaganju u pogodovanju vjerovnika) ukoliko unatoč izričitoj zabrani ipak sklopi
    ugovor o obračunskom plaćanju u cilju naplate svojeg potraživanja prije drugih
    vjerovnika, koji prema redoslijedu naplate s blokiranog računa dužnika imaju prednost
    pri namirenju, a u tom slučaju i odgovara trećima za nastalu štetu.   <p></strong>
    <p><strong>Dužnik (poslovni subjekt) kojemu je blokiran račun odnosno koji ima oznaku zabranu raspolaganja oročenim novčanim sredstvima ne smije svoje obveze plaćati gotovim novcem, plaćati preko institucije za platni promet niti preko ostalih pružatelja platnih usluga u Republici Hrvatskoj, kao niti plaćati ili primati plaćanja preko računa otvorenog kod pružatelja platnih usluga u inozemstvu, a ne smije niti preusmjeravati novčane i financijske tijekove na drugu osobu niti primati uplate i isplaćivati novčana sredstva na račune drugih osoba.<p></strong>

    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Inzistiranje na potpisu dužnika</strong></p>
    <p>Pojašnjenje: dužnik ne mora potpisati ugovor o cesiji, nego samo mora biti obaviješten o istome.</p>
    <p><strong>- Sklapanje ugovora o preuzimanju duga umjesto ugovora o cesiji</strong></p>
    <p>Pojašnjenje: cesiju/e (redovita cesija, cesija umjesto ispunjenja/plaćanja, cesija radi ispunjenja, cesija radi osiguranja), kao promjene vjerovnika bitno je razlikovati od promjena na strani dužnika (preuzimanje duga, pristupanje dugu, preuzimanje ispunjenja), a poglavito u odnosu na ugovor o preuzimanju duga.</p>
    <p>Ugovor o preuzimanju duga je trostrani ugovor (cesija je dvostrani) u kojemu dolazi do promjene dužnika, na način da umjesto postojećeg dužnika dug preuzima novi dužnik, uz pristanak vjerovnika.</p>
    <p>Ukoliko se dužnik dogovori s novim dužnikom da će preuzeti njegov dug prema vjerovniku, tada se zaključuje ugovor o preuzimanju duga, no ukoliko se vjerovnik dogovori s novim vjerovnikom (bez pristanka dužnika) da će mu ustupiti tražbinu (umjesto plaćanja obveza postojećeg vjerovnika prema novom vjerovniku), tada postojeći vjerovnik i novi vjerovnik zaključuju <strong>ugovor o cesiji umjesto plaćanja</strong> kojemu dužnik nije ugovorna strana, nego se o izvršenoj cesiji samo obavješćuje.</p>
    <p>Dakle, isti poslovni odnos između dužnika i vjerovnika može biti reguliran kroz ugovor o cesiji umjesto plaćanja ili kroz ugovor o preuzimanju duga, <strong>no bitno je točno razumjeti i odabrati onaj ugovor koji će predstavljati pravu volju ugovornih strana.</strong></p>
    <p><strong>- Sklapanje ugovora o cesiji bez predaje odgovarajuće dokumentacije o tražbini</strong><p>
    <p>Pojašnjenje: vrlo je važno da postojeći vjerovnik preda novom vjerovniku sve isprave (račune, eventualne otpremnice i sl.) koje se odnose na tražbinu kako bi mogli u eventualnom sporu dokazati da tražbina postoji.</p>

    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      prefix: "CEDENT (STARI VJEROVNIK):",
      signature: "Za CEDENTA:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nCESIONAR (NOVI VJEROVNIK):",
      signature: "Za CESIONARA:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }
    ],
    suffix: ","
    }
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O CESIJI (USTUPU TRAŽBINE) - CESIJA RADI OSIGURANJA",

  articles: [
    {
      title: 'UVODNE ODREDBE',
      mandatory: true,
      statements: [
          {
              type: 'input',
              mandatory: true,
              editable: false,
              parts: [
                
                  { type: "text", content: "Ugovorne strane suglasno utvrđuju da CEDENT potražuje od" },
                  { type: "input", value: "", required: true,    placeholder: "Naziv dužnika",},
                  { type: "text", content: "," },
                  { type: "input", value: "", required: true,  placeholder: "Mjesto"  },
                  { type: "text", content: "," },
                  { type: "input", value: "", required: true,  placeholder: "Ulica i kućni broj"  },
                  { type: "text", content: ", OIB:" },
                  { type: "input", value: "", required: true,    },
                  { type: "text", content: "(u daljnjem tekstu: CESUS, DUŽNIK), iznos od",  }, 
                  { type: "input", value: '', required: true, help: "Unijeti iznos i valutu.",}, 
                  { type: "text", content: "" },
              ]
          },
     
      ],
  },
  {
    title: "",
    mandatory: false,
    statements: [
      {
        type: "text",
        mandatory: true,
        editable: true,
        content: "Ugovorne strane suglasno izjavljuju da je prethodno navedeni iznos tražbine CEDENTA prema DUŽNIKU naveden isključivo u svrhu provedbe ovog Ugovora te da tražbina CEDENTA prema DUŽNIKU eventualno može biti i veća."
      }
    ]
  },
  {
    title: "PREDMET UGOVORA",
    mandatory: true,
    statements: [
      {
        type: "text",
        mandatory: true,
        content: "Ovim Ugovorom CEDENT ustupa CESIONARU tražbinu prema CESUSU u opsegu određenom ovim Ugovorom, a radi osiguranja ispunjenja obveze CEDENTA prema CESIONARU, pri čemu se obveza CEDENTA prema CESIONARU gasi tek u trenutku kada CESIONAR naplati ustupljenu tražbinu."
      },
      {
        type: "text",
        mandatory: true,
        content: "\r\nCESIONAR je dužan s pažnjom dobrog gospodarstvenika brinuti se o naplati ustupljene tražbine te je po naplati dužan CEDENTU predati sve što je primio preko iznosa opsega ustupanja tražbine određenog ovim Ugovorom."
      },
    ]
  },
    {
      title: "OPSEG CESIJE",
      mandatory: true,
      editable: true,
      statements: [
      {
      type: "choice",
      mandatory: true,
      choices: [
      { parts: [{ type: "text", content: "Ovim Ugovorom, radi osiguranja ispunjenja obveze CEDENTA prema CESIONARU,  CEDENT ustupa CESIONARU cjelokupan iznos tražbine prema DUŽNIKU naveden u ovom Ugovoru." }] },
      { parts: [{ type: "text", content: "Ovim Ugovorom, radi osiguranja ispunjenja obveze CEDENTA prema CESIONARU,  CEDENT ustupa CESIONARU dio tražbine prema DUŽNIKU u iznosu od" },
      { type: "input", value: ""},
      {help: "Ukoliko ne želite cesiju ukupnog iznosa tražbine, ovdje upisujete dio vrijednosti tražbine koji želite ustupiti ovim Ugovorom.", required: true},],  
    },
  ]
},
]
},

    {
      title: "ODGOVORNOST ZA POSTOJANJE TRAŽBINE",
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "CEDENT izričito izjavljuje CESIONARU da tražbina koja se ustupa ovim Ugovorom, nije ustupljena, kompenzirana, namirena, niti je prestala na bilo koji drugi način."
        }
      ]
    },
    {
      title: "ODGOVORNOST ZA NAPLATIVOST",
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "CEDENT odgovara CESIONARU za naplativost prenesene tražbine iz ovog Ugovora.",
            "CEDENT ne odgovara CESIONARU za naplativost prenesene tražbine iz ovog Ugovora."
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        }
      ]
    },
    {
      title: "ISPRAVE",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "CEDENT se obvezuje CESIONARU predati sve isprave (račune i sl.) koje dokazuju postojanje i visinu tražbine iz ovog Ugovora."
        }
      ]
    },
    {
      title: "OBAVJEŠĆIVANJE DUŽNIKA",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          choices: [
            { parts: [{ type: "text", content: "CEDENT je dužan obavijestiti DUŽNIKA o ustupljenoj tražbini iz ovog Ugovora.",  help: "Obavješćivanje cesusa (dužnika) o ustupanju tražbine predstavlja zakonsku obvezu cedenta (starog vjerovnika), no dužnika može o cesiji obavijestiti i cesionar (novi vjerovnik) te obojica zajednički.",}] },
            { parts: [{ type: "text", content: "CEDENT i CESIONAR će zajedničkim dopisom obavijestiti DUŽNIKA o ustupljenoj tražbini  iz ovog Ugovora." }] },
            { parts: [{ type: "text", content: "CESIONAR  se obvezuje samostalno obavijestiti DUŽNIKA o ustupljenoj tražbini iz ovog Ugovora." }] },
            { parts: [{ type: "text", content: "Potpisom u podnožju ovog Ugovora, DUŽNIK potvrđuje da je obaviješten o prijenosu tražbine iz ovog Ugovora s CEDENTA na CESIONARA te se obvezuje tražbinu CESIONARA evidentirati kao dugovanje u svojim poslovnim knjigama te valjano ispuniti CESIONARU." }] },
          ],
        }
      ]
    },
    {
      title: "MJERODAVNO PRAVO",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorne strane suglasno utvrđuju da će se na sve odnose koji nisu riješeni ovim ugovorom primjenjivati odredbe važećih propisa Republike Hrvatske, a primarno odredbe Zakona o obveznim odnosima."
        }
      ]
    },
    {
      title: "NADLEŽNOST",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu CEDENTA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu CESIONARA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u " },
                { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true },
              ]
            }
          ],
        }
      ]
    },
    {
      title: "PRIMJENA UGOVORA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovor se primjenjuje od trenutka potpisa ugovornih strana."
        }
      ]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 3 (tri) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak, 1 (jedan) primjerak zadržava DUŽNIK.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures
    statements: [],
  },
  {
    static: true,
    mandatory: true,
    type: 4, 
    statements: [
      {
        type: 'text',
        mandatory: true,
        editable: true,
        content: '\r\nCESUS (DUŽNIK) svojim potpisom ovdje, potvrđuje da je dana _________ obaviješten o prijenosu tražbine iz ovog Ugovora s CEDENTA na CESIONARA te se istu obvezuje ispuniti CESIONARU.\r\n\r\nZa CESUSA (DUŽNIKA): ____________________\r\n\r\n',
        help: "Iako je cesija dvostrani pravni posao kod kojega potpis/pristanak dužnika nije potreban, no svakako ga je potrebno obavijestiti o ustupanju tražbine, što predstavlja zakonsku obvezu cedenta (starog vjerovnika).",

      },
    ]
  },
],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/22_cesija_radi_osiguranja.ts